import styled from "styled-components";
import { colors } from "@/theme";

export const BorderedCheckboxContainer = styled.div`
  width: 145px;
  padding: 16px;
  border: ${`1px solid ${colors.black}`};
  border-radius: 12px;
`;
